import {
  getProgressTitle,
  PROGRESS_STATUSES,
} from "./../../config/progressConfigs";

import ProgressDetails from "./ProgressDetails";

function ProgressStatusIcon({ status }) {
  switch (status) {
    case PROGRESS_STATUSES.COMPLETED:
      return (
        <span
          className="progress-status-icon progress-status-icon--completed"
          aria-hidden="true"
        >
          ✓
        </span>
      );

    case PROGRESS_STATUSES.FAILED:
      return (
        <span
          className="progress-status-icon progress-status-icon--failed"
          aria-hidden="true"
        >
          !
        </span>
      );

    case PROGRESS_STATUSES.STARTED:
    default:
      return (
        <span
          className="progress-status-icon progress-status-icon--started"
          aria-hidden="true"
        />
      );
  }
}

export default function ProgressItem({ event }) {
  const title = getProgressTitle(event);

  return (
    <li
      className={`progress-item progress-item--${event.status}`}
      data-status={event.status}
    >
      <div className="progress-item__icon-container">
        <ProgressStatusIcon status={event.status} />
      </div>

      <div className="progress-item__content">
        <div className="progress-item__title">
          {title}
        </div>

        <ProgressDetails event={event} />
      </div>
    </li>
  );
}
